import React from 'react';

export const OverlayAbsolute = () => {
  return <div className="overlay absolute top-0 left-0 h-full w-full bg-page/60" />;
};
